function getYearText(startDate?: string, endDate?: string) {
  const startYear = startDate ? new Date(startDate).getFullYear() : undefined;
  const endYear = endDate ? new Date(endDate).getFullYear() : undefined;
  const isOneYear = startYear === endYear;

  const yearText =
    (startYear ? startYear : '') + (startYear && endYear && !isOneYear ? '-' : '') + (endYear && !isOneYear ? endYear - 2000 : '');

  return yearText;
}

export default getYearText;
